module.exports = __webpack_public_path__ + "img/desktop.efacfa72.png";